/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { METRICS, DIMENSIONS, VISUALIZATIONS } from '@/constants/DashboardConstants';

export interface Dashboard {
  id: string;
  name: string;
}
export interface DashboardBlock {
  id: string;
  name: string;
  settings: DashboardBlockSettings;
}

interface DashboardBlockSettings {
  metric: METRICS;
  dimension: DIMENSIONS;
  visualization: VISUALIZATIONS;
  filters: Array<any>;
}

export enum DimensionType {
  ATTRIBUTE = 'ATTRIBUTE',
  CUSTOM_ATTRIBUTE = 'CUSTOM_ATTRIBUTE',
  MAPPING = 'MAPPING',
  MAPPING_ATTR = 'MAPPING_ATTR',
}

export enum DimensionOptionGroupType {
  ATTRIBUTE = 0,
  CUSTOM_ATTRIBUTE = 1,
  MAPPING = 2,
}

export interface DashboardTitleErrors {
  titleExists: boolean;
  titleTooLong: boolean;
}
